var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ReservasCuenta',{attrs:{"tipo":"realizadas"}})
}
var staticRenderFns = []

export { render, staticRenderFns }